import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    minHeight: 'calc(100vh - 200px)',
    marginTop: '2.5rem'
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px'
  },
  progressContainer: {
    marginBottom: '1.25rem'
  },
  errorBox: {
    padding: '0.75rem 1rem',
    backgroundColor: '#fef2f2',
    border: '1px solid #fecaca',
    borderRadius: '8px',
    marginBottom: '1.25rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },
  errorText: {
    color: '#991b1b',
    fontWeight: 500,
    fontSize: '0.875rem'
  },
  stepsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0',
    position: 'relative'
  }
});

export default useStyles;
